import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';import { concatLatestFrom } from '@ngrx/operators';

import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, concatMap, map, switchMap, tap } from 'rxjs/operators';
import { LogService } from '../../core/log/log.service';
import { onlyWhenAuthenticated, onlyWhenOnline } from '../../shared/util/operators';
import { ErrorMessage } from '../error/error-message.model';
import {
	checkCodiceSconto,
	checkCodiceScontoFailure,
	checkCodiceScontoSuccess,
	checkErrorCodiceScontoSuccess,
	clearErrorToken,
	confirmCardPaymentAction,
	confirmCardPaymentFailure,
	confirmSubscriptionSuccess,
	createCoupon,
	createCouponFailure,
	createCouponSuccess,
	intentSubscriptionAction,
	intentSubscriptionFailure,
	intentSubscriptionSuccess,
	loadDiscountType,
	loadDiscountTypeFailure,
	loadDiscountTypeSuccess,
	loadPremiumModules,
	loadPremiumModulesFailure,
	loadPremiumModulesSuccess,
	loadUserPremiumAction,
	loadUserPremiumFailure,
	loadUserPremiumSuccess,
	setPaymentStatus,
	setSubscriptionFailure,
	setSubscriptionSuccess,
	updateSubscription,
	updateSubscriptionFailure,
	updateSubscriptionSuccess
} from './extra.actions';
import { ExtraService } from './extra.service';
import {
	CompletePaymentIntent,
	CouponState,
	MyPremium,
	MyPremiumState,
	PremiumDiscountType,
	PremiumModuleElement,
	PremiumModules,
	PremiumTokenError
} from './extra.model';
import { PaymentIntent } from '@stripe/stripe-js';
import {
	showSnackbar,
	showSnackbarFromComponent
} from '../../core/notifications/notification.actions';
import { NotificationService } from '../../core/notifications/notification.service';
import { TranslateService } from '@ngx-translate/core';
import { setPremiumInStore } from '../user/user.actions';
import { navigateToPage } from '../../core/router/routes.actions';
import { openDialog } from '../../shared/dialog/dn-dialog.actions';
import { ExtraSnackbarComponent } from '../../shared/snackbar/extra-snackbar/extra-snackbar.component';
import { SeverityDN, SnackbarStyles } from '../../core/notifications/notification.model';
import { selectUserId } from '../user/user.selectors';
import { selectSessionID } from '../../core/session/session.selectors';

@Injectable({ providedIn: 'root' })
export class ExtraEffects {
	loadPremiumModules$ = createEffect(() =>
		this.actions$.pipe(
			ofType(loadPremiumModules),
			onlyWhenOnline(this.store),
			onlyWhenAuthenticated(this.store),
			tap(() => this.logService.debug('Effect: loadPremiumModules')),
			switchMap((action) =>
				this.extraService.loadPremiumModules(action.userId, action.forcedCampaigns).pipe(
					tap((premiumModules: PremiumModuleElement[]) =>
						this.logService.info('Ho ricevuto i moduli premium: ', premiumModules)
					),
					map((premiumModules: PremiumModuleElement[]) =>
						loadPremiumModulesSuccess({ premiumModules })
					),
					catchError((error: ErrorMessage) => of(loadPremiumModulesFailure({ error })))
				)
			)
		)
	);

	//  load failure
	loadPremiumModulesFailure$ = createEffect(() =>
		this.actions$.pipe(
			ofType(loadPremiumModulesFailure),
			tap((payload) => this.logService.info('Effect: loadContentFailure', payload.error)),
      map(() => showSnackbarFromComponent({
        component: ExtraSnackbarComponent,
        payload: this.notificationService.getNotification(
          SeverityDN.ERROR,
          0,
          this.ts.instant('dottnet.extra.error'),
          this.ts.instant('dottnet.notification.ok'),
          0,
          SnackbarStyles.NONE
        ),
        verticalPosition: 'top'
      })
	)));

	checkCodiceSconto$ = createEffect(() =>
		this.actions$.pipe(
			ofType(checkCodiceSconto),
			onlyWhenOnline(this.store),
			onlyWhenAuthenticated(this.store),
			tap(() => this.logService.debug('Effect: checkCodiceSconto')),
			switchMap((action) =>
				this.extraService.checkCodiceSconto(action.token, action.userId).pipe(
					tap((codiceScontoCheck: PremiumModules) =>
						this.logService.info('Ho ricevuto i dati del token: ', codiceScontoCheck)
					),
					concatMap((codiceScontoCheck: PremiumModules) => {
						if ((<PremiumTokenError>codiceScontoCheck).errorCode > 0) {
							return [
								checkErrorCodiceScontoSuccess({
									codiceScontoCheck: <PremiumTokenError>codiceScontoCheck
								})
							];
						} else {
							return [
								clearErrorToken(),
								checkCodiceScontoSuccess({
									codiceScontoCheck: <PremiumModuleElement[]>codiceScontoCheck
								})
							];
						}
					}),

					catchError((error: ErrorMessage) => of(checkCodiceScontoFailure({ error })))
				)
			)
		)
	);


  checkCodiceScontoFailure$ = createEffect(() =>
  this.actions$.pipe(
    ofType(checkCodiceScontoFailure),
    tap((payload) => this.logService.info('Effect: checkCodiceScontoFailure', payload.error)),
    map(() => showSnackbarFromComponent({
      component: ExtraSnackbarComponent,
      payload: this.notificationService.getNotification(
        SeverityDN.ERROR,
        0,
        this.ts.instant('dottnet.extra.error'),
        this.ts.instant('dottnet.notification.ok'),
        0,
        SnackbarStyles.NONE
      ),
      verticalPosition: 'top'
    })
)));

	// setSubscrition$ = createEffect(() =>
	// 	this.actions$.pipe(
	// 		ofType(setSubscription),
	// 		onlyWhenOnline(this.store),
	// 		onlyWhenAuthenticated(this.store),
	// 		tap(() => this.logService.debug('Effect: setSubscription')),
	// 		switchMap((action) =>
	// 			this.extraService.setSubscription(action.subscription).pipe(
	// 				tap((activeSubscription: boolean) =>
	// 					this.logService.info('activeSubscription: ', activeSubscription)
	// 				),
	// 				map((activeSubscription: boolean) =>
	// 					setSubscriptionSuccess({ subscriptionSuccess: activeSubscription })
	// 				),
	// 				catchError((error: ErrorMessage) => of(setSubscriptionFailure({ error })))
	// 			)
	// 		)
	// 	)
	// );

  setSubscriptionFailure$ = createEffect(() =>
  this.actions$.pipe(
    ofType(setSubscriptionFailure),
    tap((payload) => this.logService.info('Effect: setSubscriptionFailure', payload.error)),
    map(() => showSnackbarFromComponent({
      component: ExtraSnackbarComponent,
      payload: this.notificationService.getNotification(
        SeverityDN.ERROR,
        0,
        this.ts.instant('dottnet.extra.error'),
        this.ts.instant('dottnet.notification.ok'),
        0,
        SnackbarStyles.NONE
      ),
      verticalPosition: 'top'
    })
)));

	loadUserPremium$ = createEffect(() =>
		this.actions$.pipe(
			ofType(loadUserPremiumAction),
			onlyWhenOnline(this.store),
			onlyWhenAuthenticated(this.store),
			tap(() => this.logService.debug('Effect: loadUserPremiumAction')),
			switchMap((action) =>
				this.extraService.loadUserPremium(action.userId).pipe(
					tap((myPremium: MyPremiumState) =>
						this.logService.info('Ho ricevuto myPremium: ', myPremium)
					),
					map((myPremium: MyPremiumState) => loadUserPremiumSuccess({ myPremium })),
					catchError((error: ErrorMessage) => of(loadUserPremiumFailure({ error })))
				)
			)
		)
	);

  loadUserPremiumFailure$ = createEffect(() =>
  this.actions$.pipe(
    ofType(loadUserPremiumFailure),
    tap((payload) => this.logService.info('Effect: loadUserPremiumFailure', payload.error)),
    map(() => showSnackbarFromComponent({
      component: ExtraSnackbarComponent,
      payload: this.notificationService.getNotification(
        SeverityDN.ERROR,
        0,
        this.ts.instant('dottnet.extra.error'),
        this.ts.instant('dottnet.notification.ok'),
        0,
        SnackbarStyles.NONE
      ),
      verticalPosition: 'top'
    })
)));


	loadDiscountType$ = createEffect(() =>
		this.actions$.pipe(
			ofType(loadDiscountType),
			onlyWhenOnline(this.store),
			onlyWhenAuthenticated(this.store),
			tap(() => this.logService.debug('Effect: loadDiscountType')),
			switchMap((action) =>
				this.extraService.loadDiscountType().pipe(
					tap((discountType: PremiumDiscountType[]) =>
						this.logService.info('Ho ricevuto discountType: ', discountType)
					),
					map((discountType: PremiumDiscountType[]) => loadDiscountTypeSuccess({ discountType })),
					catchError((error: ErrorMessage) => of(loadDiscountTypeFailure({ error })))
				)
			)
		)
	);


  loadDiscountTypeFailure$ = createEffect(() =>
  this.actions$.pipe(
    ofType(loadDiscountTypeFailure),
    tap((payload) => this.logService.info('Effect: loadDiscountTypeFailure', payload.error)),
    map(() => showSnackbarFromComponent({
      component: ExtraSnackbarComponent,
      payload: this.notificationService.getNotification(
        SeverityDN.ERROR,
        0,
        this.ts.instant('dottnet.extra.error'),
        this.ts.instant('dottnet.notification.ok'),
        0,
        SnackbarStyles.NONE
      ),
      verticalPosition: 'top'
    })
)));

	createCoupon$ = createEffect(() =>
		this.actions$.pipe(
			ofType(createCoupon),
			onlyWhenOnline(this.store),
			onlyWhenAuthenticated(this.store),
			tap(() => this.logService.debug('Effect: createCoupon')),
			switchMap((action) =>
				this.extraService.createCoupon(action.idTipoSconto, action.userId).pipe(
					tap((coupon: CouponState) => this.logService.info('Ho ricevuto coupon: ', coupon)),
					map((coupon: CouponState) => createCouponSuccess({ coupon })),
					catchError((error: ErrorMessage) => of(createCouponFailure({ error })))
				)
			)
		)
	);

  createCouponFailure$ = createEffect(() =>
  this.actions$.pipe(
    ofType(createCouponFailure),
    tap((payload) => this.logService.info('Effect: createCouponFailure', payload.error)),
    map(() => showSnackbarFromComponent({
      component: ExtraSnackbarComponent,
      payload: this.notificationService.getNotification(
        SeverityDN.ERROR,
        0,
        this.ts.instant('dottnet.extra.error'),
        this.ts.instant('dottnet.notification.ok'),
        0,
        SnackbarStyles.NONE
      ),
      verticalPosition: 'top'
    })
)));

	updateSubscription$ = createEffect(() =>
		this.actions$.pipe(
			ofType(updateSubscription),
			onlyWhenOnline(this.store),
			onlyWhenAuthenticated(this.store),
			tap(() => this.logService.debug('Effect: updateSubscription')),
			switchMap((action) =>
				this.extraService.updateSubscription(action).pipe(
					tap((subsState: boolean) =>
						this.logService.info('updateSubscription state: ', subsState)
					),
					map((subsState: boolean) =>
						updateSubscriptionSuccess({ updateSubscriptionSuccess: subsState })
					),
					catchError((error: ErrorMessage) => of(updateSubscriptionFailure({ error })))
				)
			)
		)
	);


  updateSubscriptionSuccess$ = createEffect(() =>
  this.actions$.pipe(
    ofType(updateSubscriptionSuccess),
    onlyWhenOnline(this.store),
    onlyWhenAuthenticated(this.store),
    tap(() => this.logService.debug('Effect: updateSubscriptionSuccess')),
    concatLatestFrom(() => this.store.select(selectUserId)),
			concatMap(([_,userId]) =>
         [
           showSnackbarFromComponent({
            component: ExtraSnackbarComponent,
            payload: this.notificationService.getNotification(
              SeverityDN.SUCCESS,
              0,
              this.ts.instant('dottnet.extra.disdetta'),
              this.ts.instant('dottnet.notification.ok'),
              0,
              SnackbarStyles.NONE
            ),
            verticalPosition: 'top'
          }),
          loadUserPremiumAction({
            userId: userId
         })
        ]
      )));


  updateSubscriptionFailure$ = createEffect(() =>
  this.actions$.pipe(
    ofType(updateSubscriptionFailure),
    tap((payload) => this.logService.info('Effect: updateSubscriptionFailure', payload.error)),
    map(() => showSnackbarFromComponent({
      component: ExtraSnackbarComponent,
      payload: this.notificationService.getNotification(
        SeverityDN.ERROR,
        0,
        this.ts.instant('dottnet.extra.error'),
        this.ts.instant('dottnet.notification.ok'),
        0,
        SnackbarStyles.NONE
      ),
      verticalPosition: 'top'
    })
)));

	intentSubscriptionAction$ = createEffect(() =>
		this.actions$.pipe(
			ofType(intentSubscriptionAction),
			onlyWhenOnline(this.store),
			onlyWhenAuthenticated(this.store),
			tap(() => this.logService.debug('Effect: intentSubscriptionAction')),
			switchMap((action) =>
				this.extraService.intentSubscriptionAction(action.subscription).pipe(
					tap((subsState: CompletePaymentIntent) =>
						this.logService.info('intentSubscription state: ', subsState)
					),
					map((subsState: CompletePaymentIntent) =>
						intentSubscriptionSuccess({ intentSubscriptionSuccess: subsState })
					),
					catchError((error: ErrorMessage) => of(intentSubscriptionFailure({ error })))
				)
			)
		)
	);

  intentSubscriptionFailure$ = createEffect(() =>
  this.actions$.pipe(
    ofType(intentSubscriptionFailure),
    tap((payload) => this.logService.info('Effect: intentSubscriptionFailure', payload.error)),
    map(() => showSnackbarFromComponent({
      component: ExtraSnackbarComponent,
      payload: this.notificationService.getNotification(
        SeverityDN.ERROR,
        0,
        this.ts.instant('dottnet.extra.error'),
        this.ts.instant('dottnet.notification.ok'),
        0,
        SnackbarStyles.NONE
      ),
      verticalPosition: 'top'
    })
)));

	confirmCardPaymentAction$ = createEffect(() =>
		this.actions$.pipe(
			ofType(confirmCardPaymentAction),
			onlyWhenOnline(this.store),
			onlyWhenAuthenticated(this.store),
			tap(() => this.logService.debug('Effect: confirmCardPaymentAction')),
			switchMap((action) =>
				this.extraService.confirmCardPaymentAction(action.paymentConfirmation).pipe(
					tap((confirmation: CompletePaymentIntent) =>
						this.logService.info('confirmCardPaymentAction state: ', confirmation)
					),
					concatMap((confirmation: CompletePaymentIntent) => {
            if(confirmation.paymentIntent.status === 'requires_action') {
              return [setPaymentStatus({ paymentIntentStatus: confirmation.paymentIntent, stripeId: confirmation.stripeId})];
            } else if(confirmation.paymentIntent.status === 'succeeded'){
              return [
                setPaymentStatus({ paymentIntentStatus: confirmation.paymentIntent, stripeId: confirmation.stripeId}),
                confirmSubscriptionSuccess({
                stripeId: confirmation.stripeId,
                currentUrl: action.currentUrl
              })
            ];
            }else{
              return [
                setPaymentStatus({ paymentIntentStatus: confirmation.paymentIntent, stripeId: confirmation.stripeId }),
                showSnackbarFromComponent({
                component: ExtraSnackbarComponent,
                payload: this.notificationService.getNotification(
                  SeverityDN.ERROR,
                  0,
                  this.ts.instant('dottnet.extra.invalidStatus') + ' ' + confirmation.paymentIntent.status,
                  this.ts.instant('dottnet.notification.ok'),
                  0,
                  SnackbarStyles.NONE
                ),
                verticalPosition: 'top'
              })];
            }
      }),
					catchError((error: ErrorMessage) => of(confirmCardPaymentFailure({ error })))
				)
			)
		)
	);

  confirmCardPaymentFailure$ = createEffect(() =>
  this.actions$.pipe(
    ofType(confirmCardPaymentFailure),
    tap((payload) => this.logService.info('Effect: confirmCardPaymentFailure', payload)),
    map((payload) => showSnackbarFromComponent({
      component: ExtraSnackbarComponent,
      payload: this.notificationService.getNotification(
        SeverityDN.ERROR,
        0,
        payload.error.messageDN,
        this.ts.instant('dottnet.notification.ok'),
        0,
        SnackbarStyles.NONE
      ),
      verticalPosition: 'top'
    })
)));

confirmSubscriptionSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(confirmSubscriptionSuccess),
			onlyWhenOnline(this.store),
			onlyWhenAuthenticated(this.store),
			tap(() => this.logService.debug('Effect: confirmSubscriptionSuccess')),
      concatLatestFrom(() => this.store.select(selectUserId)),
			concatMap(([successSubscription,userId]) => {
				if (successSubscription.currentUrl.split('/')[2] === 'discover-extra') {
					return [
						setPremiumInStore({
							premium: true,
							stripeId: successSubscription.stripeId
						}),
						showSnackbarFromComponent({
							component: ExtraSnackbarComponent,
							payload: this.notificationService.getNotification(
								SeverityDN.SUCCESS,
								0,
								this.ts.instant('dottnet.extra.welcome'),
								this.ts.instant('dottnet.notification.ok'),
								0,
								SnackbarStyles.NONE
							),
							verticalPosition: 'top'
						}),
						navigateToPage({ page: '/extra/my-extra' })
					];
				} else {
					return [
						setPremiumInStore({
							premium: true,
							stripeId: successSubscription.stripeId
						}),
						showSnackbarFromComponent({
							component: ExtraSnackbarComponent,
							payload: this.notificationService.getNotification(
								SeverityDN.SUCCESS,
								0,
								this.ts.instant('dottnet.extra.welcome'),
								this.ts.instant('dottnet.notification.ok'),
								0,
								SnackbarStyles.NONE
							),
							verticalPosition: 'top'
						}),
            loadUserPremiumAction({
							userId: userId
           }),
           loadPremiumModules({
             forcedCampaigns: 'fdsfs',
             userId: userId
          })
					];
				}
			})
		)
	);

	constructor(
		private actions$: Actions,
		private logService: LogService,
		private extraService: ExtraService,
		private notificationService: NotificationService,
		private ts: TranslateService,
		private store: Store
	) {}
}
